module.exports = __webpack_public_path__ + "static/media/businessman.7c308f60.svg";